export const userForDisplayFields = ['company', 'displayName', 'firstName', 'id', 'lastName'];
